import { atomWithSession } from '@/utils/sessionStorageAtom';

export type ScreenerFacilityChangeSource =
  | 'manual'
  | 'auto_from_all_leads'
  | 'unknown';

export const screenerFacilityChangeSourceAtom =
  atomWithSession<ScreenerFacilityChangeSource>(
    'screenerFacilityChangeSource',
    'unknown'
  );
